import { render, staticRenderFns } from "./add-bank-fee.vue?vue&type=template&id=9625252e&scoped=true"
import script from "./add-bank-fee.vue?vue&type=script&lang=js"
export * from "./add-bank-fee.vue?vue&type=script&lang=js"
import style0 from "./add-bank-fee.vue?vue&type=style&index=0&id=9625252e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9625252e",
  null
  
)

export default component.exports